export default __webpack_public_path__ + "static/media/opensea.db549214.svg";